import React, { useRef, FC, useEffect, useState } from 'react';
import { useHasMounted } from '../hooks/useHasMounted';
import { TrustpilotFragment } from '../types/graphqlTypes';
import { isBrowser } from '../utils/isBrowser';
import { Section } from './Section';

interface TrustpilotProps extends TrustpilotFragment {
  width: 'narrow' | 'wide';
}

interface TrustpilotWindow extends Window {
  Trustpilot: {
    loadFromElement: (HTMLElement, boolean) => any;
  };
}

declare const window: TrustpilotWindow;

export const Trustpilot: FC<Omit<TrustpilotProps, '__typename'>> = ({ title, tag, width }) => {
  const ref = useRef(null);
  const hasMounted = useHasMounted();
  useEffect(() => {
    if (hasMounted && isBrowser && window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, [hasMounted]);

  if (!hasMounted) {
    return null;
  }

  return (
    <Section contained heading={title || 'What our customers are saying'} narrow={width === 'narrow'}>
      <div
        ref={ref}
        className="trustpilot-widget"
        data-locale="en-GB"
        data-template-id="53aa8912dec7e10d38f59f36"
        data-businessunit-id="4bf029eb00006400050c3278"
        data-style-height="140px"
        data-style-width="100%"
        data-theme="light"
        data-stars="5"
        data-review-languages="en"
        data-text-color="#111111"
        data-tags={tag || ''}
      >
        <a href="https://uk.trustpilot.com/review/www.kfh.co.uk" target="_blank" rel="noopener noreferrer">
          Trustpilot
        </a>
      </div>
    </Section>
  );
};
